<template>
  <div class="modal-overlay" @click.self="close">
    <div class="modal-content">
      <h2>Agregar Expediente</h2>
      <form @submit.prevent="submit">
        <div class="form-group">
          <label for="number">Expediente:</label>
          <input type="text" id="number" v-model="form.number" class="form-input" />
          <div v-if="errors.number" class="error">{{ errors.number }}</div>
        </div>
        <div class="form-group">
          <label for="description">Descripción:</label>
          <textarea id="description" v-model="form.description" class="form-input"></textarea>
          <div v-if="errors.description" class="error">{{ errors.description }}</div>
        </div>
        <div class="modal-actions">
          <button type="button" class="btn-cancel" @click="close">Cancelar</button>
          <button type="submit" class="btn-save">Guardar</button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import { mapGetters, mapActions } from 'vuex';

export default defineComponent({
  name: 'AddProceedingModal',
  data() {
    return {
      form: {
        number: '',
        description: '',
      },
      errors: {
        number: '',
        description: '',
      },
    };
  },
  computed: {
    ...mapGetters({ user: 'stateUser' }),
  },
  methods: {
    ...mapActions(['createProceeding']),
    validateForm() {
      let isValid = true;
      this.errors.number = '';
      this.errors.description = '';
      if (!this.form.number) {
        this.errors.number = 'No Expediente es requerido';
        isValid = false;
      }
      if (!this.form.description) {
        this.errors.description = 'Descripción es requerida';
        isValid = false;
      }
      return isValid;
    },
    async submit() {
      if (!this.validateForm()) return;
      try {
        const proceeding = {
          number: this.form.number,
          description: this.form.description,
          user_id: this.user.id,
        };
        await this.createProceeding(proceeding);
        this.$emit('saved');
        this.close();
      } catch (error) {
        console.log(error);
      }
    },
    close() {
      this.$emit('close');
    },
  },
});
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(0,0,0,0.35);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
}
.modal-content {
  background: #fff;
  border-radius: 18px;
  padding: 2rem 2.5rem;
  min-width: 340px;
  max-width: 95vw;
  box-shadow: 0 4px 32px 0 rgba(0,0,0,0.18);
  position: relative;
}
h2 {
  margin-bottom: 1.5rem;
  font-size: 1.5rem;
  font-weight: 700;
}
.form-group {
  margin-bottom: 1.2rem;
  display: flex;
  flex-direction: column;
}
label {
  font-weight: 600;
  margin-bottom: 0.3rem;
}
.form-input {
  border: 1px solid #d1d1d1;
  border-radius: 10px;
  padding: 0.7rem 1rem;
  font-size: 1rem;
  background: #fff;
  color: #222;
  outline: none;
  transition: border 0.2s;
}
.form-input:focus {
  border-color: #a259e6;
}
.error {
  color: #e74c3c;
  font-size: 0.95em;
  margin-top: 0.2rem;
}
.modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  margin-top: 1.5rem;
}
.btn-cancel {
  background: #fff;
  color: #a259e6;
  border: 2px solid #a259e6;
  border-radius: 20px;
  padding: 0.5rem 1.5rem;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s, color 0.2s;
}
.btn-cancel:hover {
  background: #f3eaff;
  color: #6c2eb7;
}
.btn-save {
  background: #a259e6;
  color: #fff;
  border: none;
  border-radius: 20px;
  padding: 0.5rem 1.5rem;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s;
}
.btn-save:hover {
  background: #6c2eb7;
}
</style>
